import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useState } from "react";
import MockTooltipComponent from "./MockTooltipComponent";
import { useEffect } from "react";

const mockTrackingDetailsInfo = [
  {
    label: "Estimated Time of Departure",
    placeholder: "July 31, 2022",
    value: "July 31, 2022",
  },
  {
    label: "Shipping Provider",
    placeholder: "MAERSK",
    value: "MAERSK",
  },
];

const MockTrackingDetailsForm = ({ onCallBack }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [vessalNum, setVessalNum] = useState('129347128937')

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
      style={{ marginTop: "-30px" }}
    >
      <div className={classes.modalRoot}>
        <div className={classes.divStyle}>
          <Typography className={classes.composeEmailStyle}>
            Enter Vessel Tracking ID
          </Typography>
          <Icon
            baseClassName="fas"
            className="fa solid fa-xmark"
            style={{
              fontSize: "16px",
              color: "#000000",
              marginTop: "10px",
              marginLeft: "80px",
              opacity: 0.75,
            }}
          />
        </div>
        <Grid container style={{ marginTop: "24px" }}>
          <>
            <Grid item xs={12}>
              <Typography className={classes.optionLabelStyle}>
                Vessel Tracking ID
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                className={classes.textFieldStyle}
                inputProps={{
                  className: classes.inputTextStyle,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.outlineStyle,
                  },
                }}
                value={vessalNum}
                fullWidth
                onChange={(e) => { setVessalNum(e.target.value) }}
              />
            </Grid>
          </>
          {mockTrackingDetailsInfo.map((track) => (
            <>
              <Grid item xs={12}>
                <Typography className={classes.optionLabelStyle}>
                  {track.label}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  className={classes.textFieldStyle}
                  value={vessalNum ? track.value : ''}
                  inputProps={{
                    className: classes.inputTextStyle,
                  }}
                  InputProps={{
                    classes: {
                      notchedOutline: classes.outlineStyle,
                    },
                  }}
                  fullWidth
                />
              </Grid>
            </>
          ))}
          <Grid
            item
            xs={12}
            style={{ alignItems: "center", justifyContent: "flex-start" }}
          ><div
            style={{
              width: "75px",
              height: "42px",
              padding: "10px",
              backgroundColor: "#000000",
              color: "#ffffff",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "16px",
              marginTop: "6px",
            }}
          ><MockTooltipComponent
                placement="bottom-start"
                open={open}
                popper={classes.trackOrderRiskTooltip}
                arrowStyle={classes.trackOrderTooltipArrowStyle}
                title={
                  <>
                    <Typography className={classes.tooltipTitleStyle}>
                      Paste Vessel Tracking ID
                    </Typography>
                    <p className={classes.tooltipTextStyle}>
                      Paste your vessel number from your supplier’s email here.
                      <span className={classes.newLine}>
                        Press{" "}<b>Submit</b> to see your shipment’s location and port dwell
                        times.
                      </span>
                    </p>
                    <Typography className={classes.stepTextStyle}>
                      (14/19)
                    </Typography>
                  </>
                }
                child={
                  <span onClick={() => {
                    if (vessalNum) {
                      onCallBack();
                      setOpen(false);
                    }
                  }}>Submit</span>
                }
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </Dialog>

  );
};

export default MockTrackingDetailsForm;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "484px",
    height: "auto",
    padding: "16px",
  },
  composeEmailStyle: {
    fontSize: "24px",
    fontFamily: "Inter",
    fontWeight: "700",
    width: "356px",
  },
  divStyle: {
    marginBottom: "16px",
    display: "flex",
  },
  optionLabelStyle: {
    fontSize: "16px",
    fontWeight: "700",
    fontFamily: "Inter",
  },
  textFieldStyle: {
    margin: "8px 0px",
    borderRadius: "2px",
    marginBottom: "16px",
  },
  inputTextStyle: {
    padding: "10px",
    fontWeight: 400,
  },
  outlineStyle: {
    borderColor: "#E2E8F0 !important",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
  },
  trackOrderRiskTooltip: {
    width: "400px",
    height: "104px",
    marginTop: "-20px !important",
  },
  trackOrderTooltipArrowStyle: {
    // marginLeft: "128px !important",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));
